import Container from "components/ui/Container"
import { richTextToHtml } from "utils/richTextToHtml"

function PageRichText({ richText, htmlContent }) {
  // Handle direct HTML content from YAML
  if (htmlContent) {
    return (
      <Container section>
        <div
          className="prose prose-dark-grey"
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </Container>
    )
  }

  // Handle rich text format
  if (richText?.raw) {
    const richTextDoc = JSON.parse(richText.raw)
    return (
      <Container section>
        <div
          className="prose prose-dark-grey"
          dangerouslySetInnerHTML={{
            __html: richTextToHtml(richTextDoc).replace(/\n/g, `<br />`),
          }}
        />
      </Container>
    )
  }

  return null
}

export default PageRichText
